/* SK Header - JS */

(function() {

  /* ---- PORTAL: mover drawer al body DESPUES de que sk-megamenu.js inicialice ----
     El portal debe ocurrir post-init, porque sk-megamenu.js cachea listeners
     mediante root.querySelector que solo ve hijos del .sk-megamenu root.
     Si moviera antes, sk-megamenu.js no encontraria el drawer y la X, back,
     accordions y open-view quedarian sin listeners.
     El evento 'load' fire DESPUES de todos los defer scripts. */
  function portalDrawerToBody() {
    var drawer = document.querySelector('[data-sk-megamenu-drawer]');
    if (drawer && drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  /* Copia los iconos reales del header (cuenta, favoritos) al drawer.
     El drawer renderiza SVG inline por defecto; los reemplazamos con las
     mismas IMGs que usa el header para mantener consistencia visual
     y que el merchant no tenga que configurar iconos dos veces. */
  function mirrorHeaderActionsToDrawer() {
    var quickItems = document.querySelectorAll('.sk-megamenu__drawer-quick-item');
    if (!quickItems.length) return;

    /* Icono cuenta: desde .sk-header__action--account img */
    var headerAccountImg = document.querySelector('.sk-header__action--account img');
    /* Icono favoritos: desde .sk-header__action--wishlist img */
    var headerWishImg = document.querySelector('.sk-header__action--wishlist img');

    for (var i = 0; i < quickItems.length; i++) {
      var item = quickItems[i];
      var href = item.getAttribute('href') || '';
      var existingIcon = item.querySelector('svg, img');
      if (!existingIcon) continue;
      /* No sustituir si ya es img mirror (idempotencia) */
      if (existingIcon.tagName === 'IMG' && existingIcon.dataset.mirrored === 'true') continue;

      var src = null, w = 20, h = 20;
      if (/account/i.test(href) && headerAccountImg) {
        src = headerAccountImg.src;
        w = 20; h = 20;
      } else if (headerWishImg && /favorit/i.test(item.textContent)) {
        src = headerWishImg.src;
        w = 22; h = 20;
      }
      if (!src) continue;

      var newImg = document.createElement('img');
      newImg.src = src;
      newImg.width = w;
      newImg.height = h;
      newImg.alt = '';
      newImg.loading = 'eager';
      newImg.dataset.mirrored = 'true';
      existingIcon.replaceWith(newImg);
    }
  }

  /* Copia el logo del header al drawer mobile, envuelto en <a> al home */
  function mirrorHeaderLogoToDrawer() {
    var headerLogo = document.querySelector('.sk-header__logo-img');
    var drawerLogoSlot = document.querySelector('.sk-megamenu__drawer-logo');
    if (!headerLogo || !drawerLogoSlot) return;
    /* Evitar duplicar si ya se ejecuto */
    if (drawerLogoSlot.querySelector('.sk-megamenu__drawer-logo-img')) return;

    var img = document.createElement('img');
    img.className = 'sk-megamenu__drawer-logo-img';
    img.src = headerLogo.src;
    if (headerLogo.srcset) img.srcset = headerLogo.srcset;
    img.alt = headerLogo.alt || 'Inicio';
    img.loading = 'eager';
    img.width = 118;
    img.height = 35;

    var link = document.createElement('a');
    link.href = '/';
    link.className = 'sk-megamenu__drawer-logo-link';
    link.setAttribute('aria-label', headerLogo.alt || 'Inicio');
    link.appendChild(img);

    drawerLogoSlot.innerHTML = '';
    drawerLogoSlot.appendChild(link);
  }

  function setupDrawer() {
    mirrorHeaderLogoToDrawer();
    mirrorHeaderActionsToDrawer();
    portalDrawerToBody();
  }


  if (document.readyState === 'complete') {
    setupDrawer();
  } else {
    window.addEventListener('load', setupDrawer);
  }

  /* Re-ejecutar si Shopify re-renderiza la seccion en el Customizer */
  document.addEventListener('shopify:section:load', function() {
    setTimeout(setupDrawer, 50);
  });

  /* ---- Fallback: abrir drawer del megamenu ----
     sk-megamenu.js tambien engancha click en [data-sk-megamenu-drawer-open],
     pero solo si existe un [data-sk-megamenu] root en el DOM. Este fallback
     garantiza que la hamburguesa funcione incluso si sk-megamenu.js fallo
     al inicializar. Idempotente con el handler de sk-megamenu.js. */
  document.addEventListener('click', function(e) {
    var opener = e.target.closest && e.target.closest('[data-sk-megamenu-drawer-open]');
    if (!opener) return;
    var drawer = document.querySelector('[data-sk-megamenu-drawer]');
    if (!drawer) return;
    if (drawer.getAttribute('aria-hidden') === 'false') return;
    e.preventDefault();
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sk-megamenu-body-locked');
    var closeBtn = drawer.querySelector('[data-sk-drawer-close]');
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
  });

  /* ---- Marquesina infinita ---- */
  var topbar = document.querySelector('.sk-header__topbar');
  var track = document.querySelector('.sk-header__topbar-track');
  var group = track && track.querySelector('.sk-header__topbar-group');

  if (topbar && track && group) {
    var speed = 40;
    var pos = 0;
    var paused = false;
    var lastTime = null;
    var repeatW = 0;
    var frameId = 0;

    function fillTrack() {
      var clones = track.querySelectorAll('[data-clone]');
      clones.forEach(function(c) { c.remove(); });

      var containerW = topbar.offsetWidth;
      var groupW = group.offsetWidth;
      if (groupW === 0) return;

      var copies = Math.ceil(containerW / groupW) + 2;
      for (var i = 0; i < copies; i++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      /* Medir distancia exacta entre grupo original y primer clon */
      var firstClone = track.querySelector('[data-clone]');
      if (firstClone) {
        repeatW = firstClone.getBoundingClientRect().left - group.getBoundingClientRect().left;
      } else {
        repeatW = groupW;
      }
    }

    fillTrack();

    function animate(time) {
      if (lastTime === null) lastTime = time;
      var delta = time - lastTime;
      lastTime = time;

      if (!paused && repeatW > 0) {
        pos -= speed * (delta / 1000);
        /* Modulo continuo sin saltos */
        pos = ((pos % repeatW) + repeatW) % repeatW;
        /* Siempre negativo para mover a la izquierda */
        track.style.transform = 'translate3d(' + (pos - repeatW) + 'px,0,0)';
      }

      frameId = requestAnimationFrame(animate);
    }

    frameId = requestAnimationFrame(animate);

    topbar.addEventListener('mouseenter', function() { paused = true; });
    topbar.addEventListener('mouseleave', function() { paused = false; });

    /* Limpieza al destruir la seccion (Customizer) */
    document.addEventListener('shopify:section:unload', function(e) {
      if (e.target.contains(track) || e.target === track.closest('section')) {
        cancelAnimationFrame(frameId);
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        fillTrack();
        pos = 0;
      }, 200);
    });
  }

  /* ---- Toggle del panel de busqueda mobile (lupa) ----
     La lupa solo es visible <768px. Despliega .sk-header__search como
     panel absolute debajo del header (ver sk-header.css). En desktop el
     pill ya esta inline y este toggle no aplica. */
  var searchToggleBtn = document.querySelector('[data-sk-search-toggle]');
  var headerRoot = document.querySelector('.sk-header');
  var searchPanel = document.getElementById('sk-header-search-mobile');

  if (searchToggleBtn && headerRoot && searchPanel) {
    function closeSearchPanel() {
      headerRoot.classList.remove('sk-header--search-open');
      searchToggleBtn.setAttribute('aria-expanded', 'false');
    }

    function openSearchPanel() {
      headerRoot.classList.add('sk-header--search-open');
      searchToggleBtn.setAttribute('aria-expanded', 'true');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) setTimeout(function() { input.focus(); }, 50);
    }

    searchToggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (headerRoot.classList.contains('sk-header--search-open')) {
        closeSearchPanel();
      } else {
        openSearchPanel();
      }
    });

    /* Esc cierra el panel */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && headerRoot.classList.contains('sk-header--search-open')) {
        closeSearchPanel();
        searchToggleBtn.focus();
      }
    });

    /* Click fuera del panel y del boton cierra */
    document.addEventListener('click', function(e) {
      if (!headerRoot.classList.contains('sk-header--search-open')) return;
      if (searchPanel.contains(e.target) || searchToggleBtn.contains(e.target)) return;
      closeSearchPanel();
    });
  }

  /* ---- Cerrar dropdown desktop al hacer click fuera ---- */
  document.addEventListener('click', function(e) {
    var openDetails = document.querySelectorAll('.sk-header__nav-details[open]');
    openDetails.forEach(function(detail) {
      if (!detail.contains(e.target)) {
        detail.removeAttribute('open');
      }
    });
  });

  /* ---- Focus trap del drawer mobile ---- */
  var drawerDetails = document.getElementById('sk-menu-drawer');

  if (drawerDetails) {
    var previousFocus = null;
    var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function getDrawerFocusables() {
      var drawer = drawerDetails.querySelector('.sk-header__drawer');
      if (!drawer) return [];
      var elements = drawer.querySelectorAll(focusableSelector);
      var visible = [];
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].offsetParent !== null) {
          visible.push(elements[i]);
        }
      }
      return visible;
    }

    function handleDrawerKeydown(e) {
      if (e.key === 'Escape') {
        drawerDetails.removeAttribute('open');
        return;
      }

      if (e.key !== 'Tab') return;

      var focusables = getDrawerFocusables();
      if (focusables.length === 0) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (e.shiftKey) {
        /* Shift+Tab: del primero salta al ultimo */
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        /* Tab: del ultimo salta al primero */
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    drawerDetails.addEventListener('toggle', function() {
      if (drawerDetails.open) {
        /* Guardar focus previo y activar trap */
        previousFocus = document.activeElement;
        var focusables = getDrawerFocusables();
        if (focusables.length > 0) {
          /* Pequeño delay para que el drawer termine de renderizar */
          setTimeout(function() {
            focusables[0].focus();
          }, 50);
        }
        document.addEventListener('keydown', handleDrawerKeydown);
      } else {
        /* Desactivar trap y restaurar focus */
        document.removeEventListener('keydown', handleDrawerKeydown);
        if (previousFocus && previousFocus.focus) {
          previousFocus.focus();
        }
        previousFocus = null;
      }
    });
  }

  /* ---- STICKY REVEAL: ocultar la cabecera al bajar, mostrarla al subir ----
     El header.js base de Horizon NO esta cargado en este tema, asi que la
     direccion de scroll la calculamos aqui y la exponemos como clase en
     #header-group (el elemento sticky). Throttle con requestAnimationFrame. */
  (function initStickyReveal() {
    var group = document.getElementById('header-group');
    if (!group) return;

    var lastY = window.scrollY || 0;
    var ticking = false;
    var THRESHOLD = 5; /* ignora micro-scrolls que producirian parpadeo */

    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      if (Math.abs(y - lastY) < THRESHOLD) return;

      /* Bajando y ya pasado el alto del header => ocultar.
         Subiendo (o cerca del top) => mostrar. */
      if (y > lastY && y > group.offsetHeight) {
        group.classList.add('sk-header--hidden');
      } else {
        group.classList.remove('sk-header--hidden');
      }
      lastY = y;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
  })();

})();
